import Short from './Short.vue';
export default Short;


// WEBPACK FOOTER //
// ./src/components/parts/review/short/index.js